export class DriverHistoryDetails
{

   public  DriverName: string;
   public NatureOfoffence: string;
   public FinedAmount: string;
   public offenceDate: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/DriverHistoryDetails.ts